import { sendGoogleEvent } from '@html/_common/utils';

export default function SerpSponsoredCard() {
  const EVENT_CATEGORY = 'Operator Placement';
  const SPONSORED_CARD_SELECTOR = '.js-serp-sponsored-card';
  let $sponsoredCard = '';
  let operatorName = '';

  const impressionTracking = () => {
    // Impression tracking
    sendGoogleEvent(
      EVENT_CATEGORY,
      `Impression -  ${operatorName || ''}`,
      'Banner',
      {
        nonInteraction: true,
      },
    );
  };

  this.initiate = () => {
    $sponsoredCard = $(SPONSORED_CARD_SELECTOR);

    if (!$sponsoredCard.length) {
      return;
    }

    const operatorId = $sponsoredCard.data('operator-id');
    if (operatorId && window.location.href.indexOf(`operator=${operatorId}`) > -1) {
      $sponsoredCard.addClass('hid');
    }

    operatorName = $sponsoredCard.data('operator-name');

    const sponsoredCardLink = $sponsoredCard.data('link');

    $('body').on('click', SPONSORED_CARD_SELECTOR, () => {
      if (operatorId) {
        if (window.location.hash === '#_') {
          window.location.href.substr(0, window.location.href.indexOf('#'));
        }

        window.location.href = `${window.location.href}${window.location.hash ? ',' : '#'}operator=${operatorId}`;

        sendGoogleEvent(
          EVENT_CATEGORY,
          'Click',
          `${operatorName} Banner`,
        );

        window.location.reload();
      } else {
        sendGoogleEvent(
          EVENT_CATEGORY,
          'Click',
          `${operatorName} Banner`,
        );

        window.location.href = sponsoredCardLink;
      }
    });

    impressionTracking();
  };
}
